import { observable } from 'mobx';
import GdsModel from '~/glm/models/gds/gds-model';

export default class GdsCustomQuestionModel extends GdsModel {
  id;
  answerType;
  answerDestination;
  isRequired;
  text;
  type;
  @observable options;

  constructor(question = {}) {
    super();
    this.id = question.id;
    this.answerType = question.answerType;
    this.answerDestination = question.answerDestination;
    this.isRequired = question.isRequired;
    this.text = question.text;
    this.type = question.type;

    if (question.answerType === 'Option') {
      this.options = question.options;
    }
  }
}
